import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import { ListarEmpreendimentosController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { ACESSOS } from "../../../Routes/Acessos";
import ProdutoDaGestao from "./ProdutoDaGestao";
//import RegistraVenda from "./RegistraVenda";

export default function GestaoProdutos() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const history = useHistory();

    const {
        value: lstEmpreendimentos,
        loading: lstEmpreendimentosLoading,
        execute: listarEmpreendimentos,
    } = useAsyncEffect(ListarEmpreendimentosController);

    const tableColumns: Array<ColumnDescription> = [
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Produtos",
            formatter: (_, row) => (
                <ProdutoDaGestao
                    updateList={listarEmpreendimentos}
                    produto={row}
                />
            ),
        },
    ];

    return (
        <div>
            <div className="w-100 d-flex justify-content-end">
                {/* <button
                    className="btn btn-outline-primary mb-4 mr-4"
                    onClick={() => {
                        setShow(true);
                        setModal({
                            Component: () => (
                                <RegistraVenda
                                    updateList={listarEmpreendimentos}
                                    editando={false}
                                    setShow={setShow}
                                />
                            ),
                            headerComponent: "Registrar Venda",
                            size: "lg",
                        });
                    }}
                >
                    Registrar Venda
                </button> */}
                <button
                    className="btn btn-outline-primary mb-4"
                    onClick={() => {
                        history.push(
                            ACESSOS.GERAL.TELAS.CADASTRO_PRODUTO.DS_PATH
                        );
                    }}
                >
                    Cadastrar Produto
                </button>
            </div>
            <Table
                data={lstEmpreendimentos ?? []}
                loading={lstEmpreendimentosLoading}
                columns={tableColumns}
                keyField="ID_EMPREENDIMENTO"
                bordered={false}
                hover={false}
            />

            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </div>
    );
}
